import $ from "jquery";
import Fingerprint2 from "fingerprintjs2";
import {
    ajax,
    getRealEventsapi
} from "requestES";
import {
    getActivityId,
    getParam,
    getCookie,
    setCookie
} from "utilsES";

const UUID_COOKIE_NAME = 'activity_uuid'
const ACTIVITY_ID = getActivityId()
const LISTEN_BASE_URL = `//${getRealEventsapi()}/static_activity/getClickInfo?enname=${ACTIVITY_ID}&activityId=${ACTIVITY_ID}&buttonName=`

const getIEVersion = function() {
    return new Promise((resolve, reject) => {
        const userAgent = navigator.userAgent;
        const isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //是ie并且非edge
        if (isIE) {
            const reIE = new RegExp("MSIE (\\d+\\.\\d+);");
            reIE.test(userAgent);
            const IEVersion = parseFloat(RegExp["$1"]);
            resolve(IEVersion < 9 ? 8 : 10); // 小于ie9返回8，否则返回10
        } else {
            resolve(10); // 非ie
        }
    });
};

const getFinger = function() {
    return new Promise((resolve, reject) => {
        getIEVersion().then(res => {
            if (res === 10) {
                let uuid = localStorage.getItem(UUID_COOKIE_NAME);
                if (!uuid) {
                    // 未保存指纹，重新生成
                    Fingerprint2.getV18({
                        excludes: {
                            language: true
                        }
                    }, function(result, components) {
                        localStorage.setItem(UUID_COOKIE_NAME, result);
                        resolve(result);
                    });
                } else {
                    // 已保存指纹，直接获取
                    resolve(uuid);
                }
            } else {
                reject("走小于ie9的逻辑");
            }
        });
    });
};

const getUUId = function() {
    return new Promise((resolve, reject) => {
        let uuid = getCookie(UUID_COOKIE_NAME);
        if (!uuid) {
            // 未保存UUID，请求获取
            ajax({
                    url: `//${getRealEventsapi()}/static_activity/getUUID`
                })
                .then(data => {
                    setCookie(UUID_COOKIE_NAME, data.uuid, 730);
                    resolve(data.uuid);
                });
        } else {
            // 已保存UUID，直接获取
            resolve(uuid);
        }
    });
};

// 访问统计
export const stat = function() {
    let url = `//${getRealEventsapi()}/static_activity/visit_log?name=${ACTIVITY_ID}&source_url=${encodeURIComponent(window.location.href)}&referer_url=${encodeURIComponent(document.referrer)}`;
    getFinger()
        .then(uuid => {
            url = url + "&uuid=" + uuid;
            ajax({
                    url: url
                })
                .catch(err => {
                    console.log(err);
                });
        }, () => {
            getUUId()
                .then(uuid => {
                    url = url + "&uuid=" + uuid;
                    ajax({
                            url: url
                        })
                        .catch(err => {
                            console.log(err);
                        });
                });
        });
};

// 打点统计()
/**
 * listen() 点击触发
 * ①：统计点击量
 * activity.listen({'btn1': '按钮1', 'btn2': '按钮2', 'btn3': '按钮3'}, 'click')
 * ②：统计点击人数
 * activity.listen({'btn1': '按钮1', 'btn2': '按钮2', 'btn3': '按钮3'}, 'user')
 */
export const listen = function(buttonInfo, type) {
    for (let key in buttonInfo) {
        document.getElementsByClassName(key)[0].onclick = function() {
            const listenKey = ACTIVITY_ID + buttonInfo[key]
            if (type === 'user' && localStorage.getItem(listenKey)) { return }
            ajax({
                url: LISTEN_BASE_URL + buttonInfo[key]
            }).then(res => {
                type === 'user' && localStorage.setItem(listenKey, 1)
            }).catch(err => {
                console.log(err)
            })
        }
    }
}

/**
 * emit() 需要时触发
 * activity.emit('xxx弹窗显示了')
 */
export const emit = function (des) {
    ajax({
        url: LISTEN_BASE_URL + des
    }).catch(err => {
        console.log(err)
    })
}